import { FLAVORS, money } from "@/data/products";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";

export const Flavors = () => {
  const [melon, pine, apple, trio] = FLAVORS;
  return (
    <section id="flavors" data-testid="flavors-section" className="bg-[#FFF4D6] py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <h2 className="font-display text-5xl md:text-7xl font-extrabold tracking-[-0.04em] leading-[0.95] max-w-3xl">
            Three fruits. <span className="font-serif-i">Zero</span> shortcuts.
          </h2>
          <p className="max-w-sm text-base text-[#2B2008]">
            Every bottle holds about 1 pound of fruit, pressed cold so the color, sugar and enzymes stay exactly as nature made them — with a splash of vegan preservative to extend shelf life.
          </p>
        </Reveal>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          <Reveal className="lg:col-span-7 lg:row-span-2"><ProductCard p={melon} big /></Reveal>
          <Reveal className="lg:col-span-5" delay={0.1}><ProductCard p={pine} /></Reveal>
          <Reveal className="lg:col-span-5" delay={0.2}><ProductCard p={apple} /></Reveal>
          <Reveal className="lg:col-span-12" delay={0.1}><ProductCard p={trio} /></Reveal>
        </div>
      </div>
    </section>
  );
};
